import { createFileRoute } from '@tanstack/react-router';

// テストスイート詳細 > テストレビュータブ。
// URL search なし。コンポーネントは index.lazy.tsx 側で遅延ロード。
export const Route = createFileRoute('/_stacktrace/test-suites/$id/_layout/test-review/_layout/')({});